/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recover_Code_LabelInputs */

const en_recover_code_label = /** @type {(inputs: Recover_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recovery code`)
};

const de_recover_code_label = /** @type {(inputs: Recover_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederherstellungscode`)
};

/**
* | output |
* | --- |
* | "Recovery code" |
*
* @param {Recover_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recover_code_label = /** @type {((inputs?: Recover_Code_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recover_Code_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recover_code_label(inputs)
	return en_recover_code_label(inputs)
});